import { h } from 'preact';
import { useMemo, useEffect, useState } from 'preact/hooks';
import ProductGroup from './product-group';
import YotpoStars from './product-stars';
import PDPAffirm from './PDPAffirm';

const ProductForm = (
  {
    isProductQuickView = false,
    quickViewVariantId = false,
    ...props
  }) => {
  
  if (!props?.product) return null;
  const [product, setProduct] = useState(props.product);
  const handleCurrentVariantUpdated = (e) => {
    if(e.detail.currentProductData){
      setProduct(e.detail.currentProductData);
    }
  }

  useEffect(() => {
    document.addEventListener("currentVariantUpdated", handleCurrentVariantUpdated);
    return () => document.removeEventListener('currentVariantUpdated', handleCurrentVariantUpdated);
  }, []);

  const productGroups = useMemo(
    () =>
      <ProductGroup
        {...props}
        isProductQuickView={isProductQuickView}
        quickViewVariantId={quickViewVariantId}
      />, [product]
  );

  const yotpoStars = useMemo(
    () => (
      <YotpoStars
        currentProduct={product}
        isProductPage={!isProductQuickView}
        isProductQuickView={isProductQuickView}
      />
    ),
    [product],
  );

  return (
    <div className={`lg:px-0 ${!isProductQuickView ? 'border-b border-grey-3 pb-7 lg:pb-8' : 'pt-5'}`}>
      <form
        method="post"
        action="/cart/add"
        acceptCharset="UTF-8"
        encType="multipart/form-data"
        noValidate="novalidate"
        data-product-form
      >
        <div className='flex flex-col pb-0 gap-2.5'>
          {!!props.showReviews && yotpoStars}
          <h2 className={`pt-0.5 ${!isProductQuickView ? 'h4' : 'h5'}`}>
            {product.title}
          </h2>
          {product.isGiftCard && <p
            className='paragraph-4'
            dangerouslySetInnerHTML={{ __html: product.description }}
          />}
          {productGroups}
          {!product.hideAffirmMessage && (
            <div>
              <PDPAffirm {...props} />
            </div>
          )}
        </div>
      </form>
    </div>
  );
};

export default ProductForm;
